import { createContext, type FC, type ReactElement, useState } from 'react';
import type { CellarModel, CellarsSortingFields, Order } from '../models';

interface ICellarsContext {
  cellarsUpdate: boolean;
  toggleUpdate: () => void;
  cellars: CellarModel[];
  setCellars: (val: CellarModel[]) => void;
  page: number;
  setPage: (val: number) => void;
  limit: number;
  setLimit: (val: number) => void;
  count: number;
  setCount: (val: number) => void;
  order: Order;
  setOrder: (val: Order) => void;
  orderBy: CellarsSortingFields;
  setOrderBy: (val: CellarsSortingFields) => void;
  loading: boolean;
  setLoading: (val: boolean) => void;
}

export const CellarsContext = createContext<ICellarsContext>({} as ICellarsContext);

export const CellarsProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [cellarsUpdate, setCellarsUpdate] = useState(false);
  const [cellars, setCellars] = useState<CellarModel[]>([]);
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [count, setCount] = useState<number>(0);
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<CellarsSortingFields>('name');
  const [loading, setLoading] = useState(false);
  const toggleUpdate = (): void => setCellarsUpdate(!cellarsUpdate);

  return (
    <CellarsContext.Provider
      value={{
        cellarsUpdate,
        toggleUpdate: toggleUpdate,
        cellars,
        setCellars,
        page,
        setPage,
        limit,
        setLimit,
        count,
        setCount,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        loading,
        setLoading
      }}
    >
      {children}
    </CellarsContext.Provider>
  );
};
